import axios from "axios";

export const fetchGetTemplateByCompanyId = async (id: string) => {
    const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

    return await axios.get(`${baseTaskUrl}/TaskTemplate/get-dropdown-list-task-template-by-company/${id}`)
};